// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1366":"0b34d868","1660":"0b34d868","5378":"edb30248"}[chunkId] + ".chunk.css";
};